/*import { fabric } from 'fabric';
const webglUtils = require('../../../../external-modules/webgl-utils'); // TODO: make webglUtils modular*/

(function (global){
	
	"use strict";

	var fabric = global.fabric || (global.fabric = {}),
			extend = fabric.util.object.extend,
			clone = fabric.util.object.clone;
	
	
/**
 * Warp filter class
 * @class fabric.Image.filters.Warp
 * @memberOf fabric.Image.filters
 * @extends fabric.Image.filters.BaseFilter
 * @see {@link fabric.Image.filters.Warp#initialize} for constructor definition
 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
 * @example
 * var filter = new fabric.Image.filters.Warp({
 *   add here an example of how to use your filter
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 *
 */
fabric.Image.filters.Warp = class extends fabric.Image.filters.BaseFilter {
  /**
   * Constructor
   * @param {Object} [options] Options object
   */
  constructor(options) {
    super();

    if (options) {
      this.setOptions(options);
    }
  }

  type = 'Warp';
  image = null;
  pixelRatio = fabric.devicePixelRatio;
  coordinates = null;
  gridCount = 14;
  ovalArc = 0;
  dofXArray = [];
  dofYArray = [];

  /**
   * Array of attributes to send with buffers. do not modify
   * @private
   */
  vertexSource = `
    attribute vec2 a_position;
    attribute vec2 a_texCoord;

    uniform vec2 u_resolution;

    varying vec2 v_texCoord;

    void main() {
      vec2 zeroToOne = a_position / u_resolution;
      vec2 zeroToTwo = zeroToOne * 2.0;
      vec2 clipSpace = zeroToTwo - 1.0;

      gl_Position = vec4(clipSpace, 0.0, 1.0);

      v_texCoord = a_texCoord;
    }
  `;

  fragmentSource = `
    precision mediump float;

    uniform sampler2D uTexture;

    varying vec2 v_texCoord;

    void main() {
      gl_FragColor = texture2D(uTexture, v_texCoord);
    }
  `;

  initWarp() {
    if (this.coordinates.length === 4) {
      this.coordinates = this.perspectiveToWarp(
        this.coordinates[0],
        this.coordinates[1],
        this.coordinates[2],
        this.coordinates[3]
      );
    }

    this.setDofMatrix();
    this.setWarpPoints(this.coordinates);

    this.setXPoints();
    this.setYPoints();

    this.applyOvalRatio();
    this.applyPixelRatio();

    const results = this.calculateCoords();
    this.vertexCoords = results.vertexCoords;
    this.warpedWidth = results.warpedWidth;
    this.warpedHeight = results.warpedHeight;
  }

  /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */
  createProgram(gl) {
    // setup GLSL program
    const program = webglUtils.createProgramFromSources(gl, [this.vertexSource, this.fragmentSource]);

    return { program };
  }

  /**
   * Apply the resize filter to the image
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyTo(options) {
    this.initWarp();

    if (options.webgl) {
      options.destinationWidth = this.warpedWidth;
      options.destinationHeight = this.warpedHeight;

      this._setupFrameBuffer(options);
      this.applyToWebGL(options);
      this._swapTextures(options);
    }
  }

  /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyToWebGL(options) {
    const gl = options.context;
    const shader = this.retrieveShader(options);
    const { program } = shader;

    // Clear the canvas
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

    // Tell it to use our program (pair of shaders)
    gl.useProgram(program);

    // look up where the vertex data needs to go.
    var positionLocation = gl.getAttribLocation(program, "a_position");
    var texcoordLocation = gl.getAttribLocation(program, "a_texCoord");

    // Create a buffer to put three 2d clip space points in
    var positionBuffer = gl.createBuffer();

    // Bind it to ARRAY_BUFFER (think of it as ARRAY_BUFFER = positionBuffer)
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    // Set a rectangle the same size as the image.
    gl.bufferData(gl.ARRAY_BUFFER, this.createVertexCoords(this.vertexCoords, this.warpedWidth, this.warpedHeight), gl.STATIC_DRAW);

    // provide texture coordinates for the rectangle.
    var texcoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texcoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, this.createTextureCoords(this.vertexCoords), gl.STATIC_DRAW);

    if (options.pass === 0 && options.originalTexture) {
      gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
    } else {
      gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
    }

    // Set the parameters so we can render any size image.
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    // lookup uniforms
    const resolutionLocation = gl.getUniformLocation(program, "u_resolution");

    // Tell WebGL how to convert from clip space to pixels
    gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);

    // Turn on the position attribute
    gl.enableVertexAttribArray(positionLocation);

    // Bind the position buffer.
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);

    // Tell the position attribute how to get data out of positionBuffer (ARRAY_BUFFER)
    gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

    // Turn on the texcoord attribute
    gl.enableVertexAttribArray(texcoordLocation);

    // Bind the position buffer.
    gl.bindBuffer(gl.ARRAY_BUFFER, texcoordBuffer);

    // Tell the position attribute how to get data out of positionBuffer (ARRAY_BUFFER)
    gl.vertexAttribPointer(texcoordLocation, 2, gl.FLOAT, false, 0, 0);

    // set the resolution
    gl.uniform2f(resolutionLocation, options.destinationWidth, options.destinationHeight);

    // Draw the results.
    gl.drawArrays(gl.TRIANGLES, 0, this.vertexCoords.length * 6);
  }

  createTextureCoords(vertexCoords) {
    const res = Math.sqrt(vertexCoords.length);
    // 2 numbers per coord; three coords per triangle; 2 triangles per square; resolution * resolution squares.
    const c = new Float32Array(vertexCoords.length * 12);

    let i = 0;
    for (let xs = 0; xs < res; xs++) {
      for (let ys = 0; ys < res; ys++) {
        // ------------------ Top Triangle
        c[i++] = xs / res;
        c[i++] = ys / res;
        c[i++] = (xs + 1) / res;
        c[i++] = ys / res;
        c[i++] = (xs + 1) / res;
        c[i++] = (ys + 1) / res;

        // ------------------ Bottom Triangle
        c[i++] = xs / res;
        c[i++] = ys / res;
        c[i++] = xs / res;
        c[i++] = (ys + 1) / res;
        c[i++] = (xs + 1) / res;
        c[i++] = (ys + 1) / res;
      }
    }

    return c;
  }

  createVertexCoords(vertexCoords, warpedWidth, warpedHeight) {
    var res = Math.sqrt(vertexCoords.length);
    //2 numbers per coord; three coords per triangle; 2 triangles per square; resolution * resolution squares.
    var c = new Float32Array(vertexCoords.length * 12);

    var i = 0;
    var vertexCounter = 0;
    for (let xs = 0; xs < res; xs++) {
      for (let ys = 0; ys < res; ys++) {
        // ------------------ Top Triangle
        c[i++] = vertexCoords[vertexCounter][0][0].x * warpedWidth;
        c[i++] = vertexCoords[vertexCounter][0][0].y * warpedHeight;

        c[i++] = vertexCoords[vertexCounter][0][1].x * warpedWidth;
        c[i++] = vertexCoords[vertexCounter][0][1].y * warpedHeight;

        c[i++] = vertexCoords[vertexCounter][0][2].x * warpedWidth;
        c[i++] = vertexCoords[vertexCounter][0][2].y * warpedHeight;

        // ------------------ Bottom Triangle
        c[i++] = vertexCoords[vertexCounter][1][0].x * warpedWidth;
        c[i++] = vertexCoords[vertexCounter][1][0].y * warpedHeight;

        c[i++] = vertexCoords[vertexCounter][1][1].x * warpedWidth;
        c[i++] = vertexCoords[vertexCounter][1][1].y * warpedHeight;

        c[i++] = vertexCoords[vertexCounter][1][2].x * warpedWidth;
        c[i++] = vertexCoords[vertexCounter][1][2].y * warpedHeight;

        vertexCounter++;
      }
    }

    return c;
  }

  perspectiveToWarp(topLeftCoords, topRightCoords, bottomLeftCoords, bottomRightCoords) {
    var topBorder = [(topRightCoords[0] - topLeftCoords[0]), (topRightCoords[1] - topLeftCoords[1])];
    var leftBorder = [(bottomLeftCoords[0] - topLeftCoords[0]), (bottomLeftCoords[1] - topLeftCoords[1])];
    var rightBorder = [(bottomRightCoords[0] - topRightCoords[0]), (bottomRightCoords[1] - topRightCoords[1])];
    var bottomBorder = [(bottomRightCoords[0] - bottomLeftCoords[0]), (bottomRightCoords[1] - bottomLeftCoords[1])];
    var warpCoords =
      [
        topLeftCoords,
        [(topLeftCoords[0] + (topBorder[0] / 3)), (topLeftCoords[1] + (topBorder[1] / 3))],
        [(topLeftCoords[0] + (2 * topBorder[0] / 3)), (topLeftCoords[1] + 2 * (topBorder[1] / 3))],
        topRightCoords,

        [(topLeftCoords[0] + (leftBorder[0] / 3)), (topLeftCoords[1] + (leftBorder[1] / 3))],
        [0, 0],
        [0, 0],
        [(topRightCoords[0] + (rightBorder[0] / 3)), (topRightCoords[1] + (rightBorder[1] / 3))],

        [(topLeftCoords[0] + (2 * leftBorder[0] / 3)), (topLeftCoords[1] + (2 * leftBorder[1] / 3))],
        [0, 0],
        [0, 0],
        [(topRightCoords[0] + (2 * rightBorder[0] / 3)), (topRightCoords[1] + (2 * rightBorder[1] / 3))],

        bottomLeftCoords,
        [(bottomLeftCoords[0] + (bottomBorder[0] / 3)), (bottomLeftCoords[1] + (bottomBorder[1] / 3))],
        [(bottomLeftCoords[0] + (2 * bottomBorder[0] / 3)), (bottomLeftCoords[1] + 2 * (bottomBorder[1] / 3))],
        bottomRightCoords,
      ];

    warpCoords[5] = [(warpCoords[4][0] + ((warpCoords[7][0] - warpCoords[4][0]) / 3)), (warpCoords[1][1] + ((warpCoords[13][1] - warpCoords[1][1]) / 3))];
    warpCoords[6] = [(warpCoords[4][0] + ((2 * (warpCoords[7][0] - warpCoords[4][0])) / 3)), (warpCoords[2][1] + ((warpCoords[14][1] - warpCoords[2][1]) / 3))];
    warpCoords[9] = [(warpCoords[8][0] + ((warpCoords[11][0] - warpCoords[8][0]) / 3)), (warpCoords[1][1] + (2 * (warpCoords[13][1] - warpCoords[1][1]) / 3))];
    warpCoords[10] = [(warpCoords[8][0] + ((2 * (warpCoords[11][0] - warpCoords[8][0])) / 3)), (warpCoords[2][1] + (2 * (warpCoords[14][1] - warpCoords[2][1]) / 3))];

    return warpCoords;
  }

  setWarpPoints(pointsCoords) {
    var coordsKey = [0, 0];
    for (let x = 0; x < 4; x++) {
      for (let y = 0; y < 4; y++) {
        this.dofXArray[coordsKey[1]][coordsKey[0]] = pointsCoords[(x * 4) + y][0];
        this.dofYArray[coordsKey[1]][coordsKey[0]] = pointsCoords[(x * 4) + y][1];
        coordsKey[1] += this.gridCount;
      }
      coordsKey[0] += this.gridCount;
      coordsKey[1] = 0;
    }
  }

  setDofMatrix() {
    for (let x = 0; x < (this.gridCount * 3) + 1; x++) {
      this.dofXArray[x] = [];
      this.dofYArray[x] = [];
      for (let y = 0; y < (this.gridCount * 3) + 1; y++) {
        this.dofXArray[x][y] = 0;
        this.dofYArray[x][y] = 0;
      }
    }
  }

  det(mat) {
    var length = mat.length;

    if (length === 1) {
      return mat[0][0];
    }

    if (length === 2) {
      return mat[0][0] * mat[1][1] - mat[0][1] * mat[1][0];
    }

    var det = 0;

    for (let j = 0; j < length; j++) {
      det += mat[0][j] * this.getDet(mat, j);
    }

    return det;
  }

  getDet(mat, columns) {
    var sub_matrix = [],
      length = mat.length,
      m = 0;

    for (let i = 1; i < length; i++) {
      sub_matrix[m] = [];

      for (let j = 0; j < length; j++) {
        if (j !== columns) {
          sub_matrix[m].push(mat[i][j]);
        }
      }

      m++;
    }

    return (columns % 2 ? -1 : 1) * this.det(sub_matrix);
  }

  doKrammer(dofX1, dofX2, dofX3, dofX4, dofY1, dofY2, dofY3, dofY4) {
    var mainDetMatrix = [
      [Math.pow(dofX1, 3), Math.pow(dofX1, 2), dofX1, 1],
      [Math.pow(dofX2, 3), Math.pow(dofX2, 2), dofX2, 1],
      [Math.pow(dofX3, 3), Math.pow(dofX3, 2), dofX3, 1],
      [Math.pow(dofX4, 3), Math.pow(dofX4, 2), dofX4, 1]
    ];

    var detAMatrix = [
      [dofY1, Math.pow(dofX1, 2), dofX1, 1],
      [dofY2, Math.pow(dofX2, 2), dofX2, 1],
      [dofY3, Math.pow(dofX3, 2), dofX3, 1],
      [dofY4, Math.pow(dofX4, 2), dofX4, 1]
    ];

    var detBMatrix = [
      [Math.pow(dofX1, 3), dofY1, dofX1, 1],
      [Math.pow(dofX2, 3), dofY2, dofX2, 1],
      [Math.pow(dofX3, 3), dofY3, dofX3, 1],
      [Math.pow(dofX4, 3), dofY4, dofX4, 1]
    ];

    var detCMatrix = [
      [Math.pow(dofX1, 3), Math.pow(dofX1, 2), dofY1, 1],
      [Math.pow(dofX2, 3), Math.pow(dofX2, 2), dofY2, 1],
      [Math.pow(dofX3, 3), Math.pow(dofX3, 2), dofY3, 1],
      [Math.pow(dofX4, 3), Math.pow(dofX4, 2), dofY4, 1]
    ];

    var detDMatrix = [
      [Math.pow(dofX1, 3), Math.pow(dofX1, 2), dofX1, dofY1],
      [Math.pow(dofX2, 3), Math.pow(dofX2, 2), dofX2, dofY2],
      [Math.pow(dofX3, 3), Math.pow(dofX3, 2), dofX3, dofY3],
      [Math.pow(dofX4, 3), Math.pow(dofX4, 2), dofX4, dofY4]
    ];

    var mainDet = this.det(mainDetMatrix);
    var detA = this.det(detAMatrix);
    var detB = this.det(detBMatrix);
    var detC = this.det(detCMatrix);
    var detD = this.det(detDMatrix);

    var polyCoeffA = detA / mainDet;
    var polyCoeffB = detB / mainDet;
    var polyCoeffC = detC / mainDet;
    var polyCoeffD = detD / mainDet;

    return [polyCoeffA, polyCoeffB, polyCoeffC, polyCoeffD];
  }

  fixVertexDistances(x) {
    const density = 1.5;
    let reverseKey;

    // From left to right fix
    for (let xx = 0; xx < (this.gridCount * 3) / 2; xx++) {
      // Vertex points can not overlay and has to be 2x more than previous vertex
      if (this.dofXArray[xx + 1][x] < this.dofXArray[xx][x]) {
        this.dofXArray[xx + 1][x] = this.dofXArray[xx][x] + Math.pow(density, xx);
      }
      // Reverse
      reverseKey = (this.gridCount * 3) - xx;
      if (this.dofXArray[(reverseKey - 1)][x] > this.dofXArray[reverseKey][x]) {
        this.dofXArray[(reverseKey - 1)][x] = this.dofXArray[reverseKey][x] - Math.pow(density, xx);
      }
    }
  }

  setXPoints() {
    for (let x = 0; x < (this.gridCount * 3) + 1; x += this.gridCount) {
      for (let xx = 0; xx < (this.gridCount * 3); xx++) {
        if (xx !== 0 && xx !== this.gridCount && xx !== 2 * this.gridCount) {
          this.dofXArray[xx][x] = (
            (
              (
                ((this.gridCount - (xx % this.gridCount)) * this.dofXArray[(Math.floor(xx / this.gridCount) * this.gridCount)][x])
                +
                ((xx % this.gridCount) * this.dofXArray[(this.gridCount + (Math.floor(xx / this.gridCount) * this.gridCount))][x])
              ) / this.gridCount
            )
          );
        }
      }

      var polyCoEffs = this.doKrammer(
        this.dofXArray[0][x], this.dofXArray[this.gridCount][x], this.dofXArray[(2 * this.gridCount)][x], this.dofXArray[(3 * this.gridCount)][x],
        this.dofYArray[0][x], this.dofYArray[this.gridCount][x], this.dofYArray[(2 * this.gridCount)][x], this.dofYArray[(3 * this.gridCount)][x]
      );

      for (let dofKey = 0; dofKey < (3 * this.gridCount); dofKey++) {
        if (dofKey !== 0 && dofKey !== this.gridCount && dofKey !== (2 * this.gridCount)) {
          this.dofYArray[dofKey][x] = (
            polyCoEffs[0] * Math.pow(this.dofXArray[dofKey][x], 3)
            + (polyCoEffs[1] * Math.pow(this.dofXArray[dofKey][x], 2))
            + (polyCoEffs[2] * this.dofXArray[dofKey][x])
            + polyCoEffs[3]
          );
        }
      }

      this.fixVertexDistances(x);
    }
  }

  setYPoints() {
    // var modifier;
    for (let x = 0; x < (this.gridCount * 3) + 1; x++) {
      for (let xx = 0; xx < (this.gridCount * 3); xx++) {
        if (xx !== 0 && xx !== this.gridCount && xx !== 2 * this.gridCount) {
          this.dofYArray[x][xx] = (
            (
              (
                ((this.gridCount - (xx % this.gridCount)) * this.dofYArray[x][(Math.floor(xx / this.gridCount) * this.gridCount)])
                +
                (((xx % this.gridCount)) * this.dofYArray[x][(this.gridCount + (Math.floor(xx / this.gridCount) * this.gridCount))])
              ) / this.gridCount
            )
          );
        }
      }

      var polyCoEffs = this.doKrammer(
        this.dofYArray[x][0], this.dofYArray[x][this.gridCount], this.dofYArray[x][(2 * this.gridCount)], this.dofYArray[x][(3 * this.gridCount)],
        this.dofXArray[x][0], this.dofXArray[x][this.gridCount], this.dofXArray[x][(2 * this.gridCount)], this.dofXArray[x][(3 * this.gridCount)]
      );

      for (let dofKey = 0; dofKey < (3 * this.gridCount); dofKey++) {
        if (dofKey !== 0 && dofKey !== this.gridCount && dofKey !== (2 * this.gridCount)) {
          this.dofXArray[x][dofKey] = (
            polyCoEffs[0] * Math.pow(this.dofYArray[x][dofKey], 3)
            + (polyCoEffs[1] * Math.pow(this.dofYArray[x][dofKey], 2))
            + (polyCoEffs[2] * this.dofYArray[x][dofKey])
            + polyCoEffs[3]
          );
        }
      }
    }
  }

  applyOvalRatio() {
    let modifier;
    const gridCountTress = (3 / 2 * this.gridCount);
    var vectorDistance = this.ovalArc / gridCountTress;

    for (let x = 0; x < this.gridCount * 3 + 1; x++) {
      for (let xx = 0; xx < this.gridCount * 3 + 1; xx++) {
        if (xx > gridCountTress) { // Left doffs
          modifier = (vectorDistance * (xx - gridCountTress));
        } else if (xx < gridCountTress) { // Right doffs
          modifier = (this.ovalArc - (vectorDistance * xx));
        } else {
          modifier = 0; // Center doffs
        }

        this.dofXArray[xx][x] = (
          (
            (
              ((modifier * this.dofXArray[Math.min(this.gridCount * 3, (Math.floor(xx / gridCountTress) * this.gridCount * 3))][x]))
              +
              ((10 - modifier) * this.dofXArray[xx][x])
            ) / (10)
          )
        );
      }
    }
  }

  applyPixelRatio() {
    for (let x = 0; x < this.dofXArray.length; x++) {
      for (let y = 0; y < this.dofXArray[0].length; y++) {
        this.dofXArray[x][y] *= this.pixelRatio;
        this.dofYArray[x][y] *= this.pixelRatio;
      }
    }
  }

  calculateCoords() {
    const vertexCoords = [];
    let minX = 99999, maxX = 0, minY = 99999, maxY = 0;

    for (let x = 0; x < this.dofXArray.length; x++) {
      for (let y = 0; y < this.dofXArray.length; y++) {
        if (minX > this.dofXArray[x][y]) {
          minX = this.dofXArray[x][y];
        }

        if (maxX < this.dofXArray[x][y]) {
          maxX = this.dofXArray[x][y];
        }
      }
    }

    for (let x = 0; x < this.dofYArray.length; x++) {
      for (let y = 0; y < this.dofYArray.length; y++) {
        if (minY > this.dofYArray[x][y]) {
          minY = this.dofYArray[x][y];
        }

        if (maxY < this.dofYArray[x][y]) {
          maxY = this.dofYArray[x][y];
        }
      }
    }

    const warpedWidth = maxX - minX;
    const warpedHeight = maxY - minY;

    for (let x = 0; x < this.dofXArray.length - 1; x++) {
      for (let y = 0; y < this.dofXArray.length - 1; y++) {
        vertexCoords.push([
          [
            { x: (this.dofXArray[x][y] - minX) / warpedWidth, y: (this.dofYArray[x][y] - minY) / warpedHeight },
            { x: (this.dofXArray[x + 1][y] - minX) / warpedWidth, y: (this.dofYArray[x + 1][y] - minY) / warpedHeight },
            { x: (this.dofXArray[x + 1][y + 1] - minX) / warpedWidth, y: (this.dofYArray[x + 1][y + 1] - minY) / warpedHeight }
          ],
          [
            { x: (this.dofXArray[x][y] - minX) / warpedWidth, y: (this.dofYArray[x][y] - minY) / warpedHeight },
            { x: (this.dofXArray[x][y + 1] - minX) / warpedWidth, y: (this.dofYArray[x][y + 1] - minY) / warpedHeight },
            { x: (this.dofXArray[x + 1][y + 1] - minX) / warpedWidth, y: (this.dofYArray[x + 1][y + 1] - minY) / warpedHeight }
          ]
        ]);
      }
    }

    return {
      vertexCoords,
      warpedWidth: warpedWidth - 1,
      warpedHeight: parseInt(warpedHeight, 10)
    };
  }

  toObject() {
    const object = { type: this.type };
    const mainP = this.mainParameter;

    if (mainP) {
      object[mainP] = this[mainP];
    }

    object.coordinates = this.coordinates;

    return object;
  }
};

/**
 * Returns filter instance from an object representation
 * @static
 * @param {Object} object Object to create an instance from
 * @param {function} [callback] to be invoked after filter creation
 * @return {fabric.Image.filters.Warp} Instance of fabric.Image.filters.Warp
 */
fabric.Image.filters.Warp.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : this);